export default class NfseCancelamento {
  justificativa = null;
  tipoCancelamento = null;

  constructor(justificativa, tipoCancelamento) {
    this.justificativa = justificativa;
    this.tipoCancelamento = tipoCancelamento;
  }
}
